import { Injectable } from '@angular/core';
import { isBrowser } from 'app/core/utils/platform.util';
import { NgxIzitoastService } from 'ngx-izitoast';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  constructor(
    private iziToast: NgxIzitoastService) { }

  showToast(msg, bgColor?, title?, time?) {
    setTimeout(() => {

      this.iziToast.show({
        title: msg,
        position: 'topCenter',
        theme: 'dark',
        transitionIn: 'bounceInDown',
        color:'var(--custom-font-color)',
        progressBar: true,
        progressBarColor: 'var(--custom-font-color)',
        backgroundColor: bgColor ?? 'var(--desku-primary-500)'
      });
    }, 0);
  }

  customErrorToast(errorText, time?) {
    if(!errorText) return;
    let errorTime = time ? time : 4000
    this.showToast(errorText, '#f44336', errorTime);
  }

  getResizedImageWidth(url: string, maxHeight: number = 55): Promise<{ width: number, height: number }> {
    if (!isBrowser() || !url) {
      return Promise.resolve({ width: 0, height: maxHeight });
    }
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        // Calculate aspect ratio
        const aspectRatio = img.width / img.height;

        // Calculate the width based on the max height
        const resizedWidth = aspectRatio * maxHeight;

        resolve({ width: resizedWidth, height: maxHeight });
      };
      img.onerror = (event) => {
        console.error(`Error loading image from URL: ${url}`, event);
        reject(new Error(`Failed to load image from URL: ${url}`)); // Reject with custom error message
      };
      img.src = url;
      img.style.objectFit = 'contain'; // Apply object-fit: contain
    });
  }

}
